import Main from './components/Main';
import Footer from './components/Footer';

export default function App() {
  return (
    <>
      <Main />
      <Footer />
    </>
  );
}
